import type { CubeApi } from "@cubejs-client/core";
import cubejs from "@cubejs-client/core";
import axios from "axios";

export const getCubeAuthToken = (): Promise<string> => {
  try {
    const oktaTokenStorage = JSON.parse(
      localStorage.getItem("okta-token-storage") ?? "{}",
    );
    const accessToken = oktaTokenStorage?.accessToken?.accessToken ?? "";

    return Promise.resolve(`Bearer ${accessToken}`);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getCubeJsApi = (): CubeApi =>
  cubejs(getCubeAuthToken, {
    apiUrl: `${axios.defaults.baseURL}analytics`,
  });
